import { ProductSummaryBlockDefinition } from 'components/common-form/sidePanel/docToolbar/summary/builder/model';
import type { ReadonlyValueDefinition } from 'models/metadata/readonlyValue.definition';
import type { QuoteWorkspaceVersion } from 'state/userPreferences/userPreferences.model';

export function useFieldNotInThisVersion(
  node: ProductSummaryBlockDefinition | ReadonlyValueDefinition,
  quoteWorkspaceVersion: QuoteWorkspaceVersion,
  mustForceAdvancedMode: boolean,
): boolean {
  if (node.isForAdvancedMode ?? false) {
    return quoteWorkspaceVersion !== 'Advanced' && mustForceAdvancedMode === false;
  }

  return false;
}
